import SlideShow from "../Reusable Elements/SlideShow";
import { designedImages } from "../../data/slideShowData";
import Button from "../Reusable Elements/Button";

const Designed = () => {
    return (
        <div className="flex w-screen items-center justify-between sm:flex-row pt-7 sm:pb-7 flex-col">
            <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[60vw] px-2 items-center gap-y-12 mb-10 sm:mb-0 pt-10 sm:pt-0">
                <div className="w-fit flex items-center flex-col">
                    <div className="font-poppins font-extralight text-5xl text-center text-primary-blue">
                        Designed Town Homes
                    </div>
                    <div className="font-poppins text-xl font-extralight text-center mt-10 sm:px-6 px-8">
                        Our stacked townhomes feature a G+2 layout with
                        independent floors designed with high-luxury solutions
                        to create functional, elegant spaces.
                    </div>
                    <div className="font-poppins text-xl font-extralight text-center mt-10 sm:px-6 px-8 mb-10">
                        We ensure efficient open layout designs and enhance
                        property value with our expert touch.
                    </div>
                    <Button
                        text={"Contact Us"}
                        color={"#ffffff"}
                        location={"/contact"}
                    />
                </div>
            </div>
            <div>
                <SlideShow side={"right"} images={designedImages} />
            </div>
        </div>
    );
};

export default Designed;
